import React from 'react';
import {
  View, StyleSheet, Text, FlexStyle,
} from 'react-native';
import { generateAvatarColor } from '../data';

interface TicketAssigneeIconProps {
  title: string,
  style?: FlexStyle | FlexStyle[]
}

export const getInitials = (title: string) => title?.split(' ')
  .filter((word: string) => word?.length > 0)
  .map((word: string) => word[0]?.toUpperCase());

const TicketAssigneeIcon = ({ title, style }: TicketAssigneeIconProps) => (
  <View style={[styles.container, { backgroundColor: generateAvatarColor(title.length) }, style]}>
    <Text style={styles.title}>
      {getInitials(title)}
    </Text>
  </View>
);

const styles = StyleSheet.create({
  container: {
    width: 20,
    aspectRatio: 1,
    borderRadius: 100,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    color: '#fff',
    fontFamily: 'Roboto_400Regular',
    fontSize: 8,
  },
});

export default TicketAssigneeIcon;
